module.exports = __webpack_public_path__ + "img/especial-dia-mulheres.daf3e2b6.jpg";